/**
 * Toggles size-guide table values between cm and inches.
 * Source values are always stored in data-cm on each cell.
 */
class SizeGuideUnits extends HTMLElement {
  connectedCallback() {
    this.#buttons.forEach((button) => {
      button.addEventListener('click', this.#onUnitClick);
    });
  }

  disconnectedCallback() {
    this.#buttons.forEach((button) => {
      button.removeEventListener('click', this.#onUnitClick);
    });
  }

  /** @returns {HTMLButtonElement[]} */
  get #buttons() {
    return Array.from(this.querySelectorAll('[data-unit]'));
  }

  /** @returns {HTMLElement[]} */
  get #cells() {
    return Array.from(this.querySelectorAll('[data-cm]'));
  }

  /** @param {MouseEvent} event */
  #onUnitClick = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const unit = button.dataset.unit;
    if (unit !== 'cm' && unit !== 'in') return;

    this.#setUnit(unit);
  };

  /** @param {'cm' | 'in'} unit */
  #setUnit(unit) {
    this.#buttons.forEach((button) => {
      const active = button.dataset.unit === unit;
      button.setAttribute('aria-pressed', String(active));
      button.classList.toggle('is-active', active);
    });

    this.#cells.forEach((cell) => {
      const cm = Number.parseFloat(cell.dataset.cm ?? '');
      if (Number.isNaN(cm)) return;

      if (unit === 'in') {
        cell.textContent = (cm / 2.54).toFixed(1);
      } else {
        cell.textContent = Number.isInteger(cm) ? String(cm) : String(cm);
      }
    });

    this.querySelectorAll('[data-unit-label]').forEach((label) => {
      label.textContent = unit;
    });
  }
}

if (!customElements.get('size-guide-units')) {
  customElements.define('size-guide-units', SizeGuideUnits);
}
